import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import LanguageSwitcher from './LanguageSwitcher';
import { Button } from './ui';
import useAuthStore from '../store/authStore';
import useTenantStore from '../store/tenantStore';

export default function PublicSiteHeader({ active }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isFeatureEnabled = useTenantStore((state) => state.isFeatureEnabled);
  const linkClass = (key) => `transition hover:text-primary-600 ${active === key ? 'font-semibold text-primary-700' : 'text-gray-600'}`;

  return (
    <header className="sticky top-0 z-30 border-b border-surface-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-4 sm:px-6">
        <Link to="/" aria-label={t('Home')}><Logo size={34} textColor="text-gray-900" /></Link>
        <nav className="hidden items-center gap-5 text-sm font-medium sm:flex lg:gap-7" aria-label={t('Main navigation')}>
          <Link to="/" className={linkClass('home')}>{t('Home')}</Link>
          <Link to="/store" className={linkClass('store')}>{t('Store')}</Link>
          {isFeatureEnabled('teacher_profiles') && <Link to="/teachers" className={linkClass('teachers')}>{t('Choose your teacher')}</Link>}
        </nav>
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <Button size="sm" onClick={() => navigate(isAuthenticated ? '/dashboard' : '/login')}>
            {isAuthenticated ? t('Dashboard') : t('Login')}
          </Button>
        </div>
      </div>
      <nav className="flex items-center justify-center gap-5 border-t border-surface-100 px-4 py-2.5 text-xs font-medium sm:hidden" aria-label={t('Main navigation')}>
        <Link to="/" className={linkClass('home')}>{t('Home')}</Link>
        <Link to="/store" className={linkClass('store')}>{t('Store')}</Link>
        {isFeatureEnabled('teacher_profiles') && <Link to="/teachers" className={linkClass('teachers')}>{t('Choose your teacher')}</Link>}
      </nav>
    </header>
  );
}
